import moment from "moment";

export const filterAppointmentsByStatut = (appointments, matchString) => {
    return appointments?.find(({ status }) =>
        new RegExp(matchString).test(status)
    );
};

export const extractDate = (appointments, statusRegex) => {
    const appointment = filterAppointmentsByStatut(appointments, statusRegex);
    return appointment ? moment(appointment.date).toDate().getTime() : null;
};

export const extractIntegrationDate = (appointments, statusRegex) => {
    const appointment = filterAppointmentsByStatut(appointments, statusRegex);
    if (!appointment || !appointment.date) return null;
    const dateFormatted = moment(appointment.date).format("DD/MM/YYYY");
    const hasIntegration = appointment.dateIntegration && appointment.dateIntegration !== "null";
    return hasIntegration
        ? dateFormatted + " - " + moment(appointment.dateIntegration).format("DD/MM/YYYY")
        : dateFormatted;
};

// Extrait les notes des rendez-vous et les retourne sous forme de tableau d'objets {note: "la note"}
export const extractNotes = (appointments) => {
    if (!appointments || appointments.length === 0) return null;
    const notes = appointments
        .filter((appt) => appt.note != null && appt.note !== "")
        .map((appt) => ({note: appt.note }));
    return notes.length > 0 ? notes : null;
};